import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { PositionType } from '../../../lib/defs/types';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';

import { Container } from '../../../odie';
import { PipeCollectedAnimation } from '../../animations/PipeCollectedAnimation';

export type PipeGoalEffectOptions = {
  position: PositionType;
  wobbleView?: Container;
};

export class PipeGoalEffect implements IEffect {
  constructor(
    private scene: GameScene,
    private options: PipeGoalEffectOptions,
  ) {}

  public static assets(): string[] {
    return [];
  }

  public async execute() {
    const goals = this.scene.sessionEntity.c.map.goals;

    // Skip if there are no pipe goals left
    if (!goals['pipe'] || goals['pipe'] === 0) return;

    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    await this.animate();
  }

  private async animate() {
    const animation = new PipeCollectedAnimation({
      wobbleView: this.options.wobbleView,
    });

    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this.scene,
      this.options.position,
      {},
      () => animation,
    );
    // run animation
    await animation.start();
    // despawn entity
    despawnOverlayEntity(this.scene, entity);
  }
}
